import { setEpicFilters } from './set-epic-filters/index.tsx';
import { setFilters } from './set-filters/index.tsx';
import { setVersionFilters } from './set-version-filters/index.tsx';
import type { Actions } from './types.tsx';

export const actions: Actions = {
	setFilters,
	setEpicFilters,
	setVersionFilters,
};
